/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtClaimReward = {
  pool: Address;
  position: Address;
  owner: Address;
  mintReward: Address;
  rewardIndex: number;
  totalReward: bigint;
};

export type EvtClaimRewardArgs = {
  pool: Address;
  position: Address;
  owner: Address;
  mintReward: Address;
  rewardIndex: number;
  totalReward: number | bigint;
};

export function getEvtClaimRewardEncoder(): FixedSizeEncoder<EvtClaimRewardArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["position", getAddressEncoder()],
    ["owner", getAddressEncoder()],
    ["mintReward", getAddressEncoder()],
    ["rewardIndex", getU8Encoder()],
    ["totalReward", getU64Encoder()],
  ]);
}

export function getEvtClaimRewardDecoder(): FixedSizeDecoder<EvtClaimReward> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["position", getAddressDecoder()],
    ["owner", getAddressDecoder()],
    ["mintReward", getAddressDecoder()],
    ["rewardIndex", getU8Decoder()],
    ["totalReward", getU64Decoder()],
  ]);
}

export function getEvtClaimRewardCodec(): FixedSizeCodec<
  EvtClaimRewardArgs,
  EvtClaimReward
> {
  return combineCodec(getEvtClaimRewardEncoder(), getEvtClaimRewardDecoder());
}
